module.exports = __webpack_public_path__ + "frontend/images/agents/hammers-xs-4dd9c1ef574f16fdbbd58576c631647d.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/agents/hammers-xs.png
// module id = 351
// module chunks = 2